// extracted by mini-css-extract-plugin
export default {"link":"ViewAll_link__K9WeT","url":"ViewAll_url__xwRyC","small":"ViewAll_small__DTYv7","large":"ViewAll_large__771TS"};